import * as types from './mutation-types'
import api from '@/modules/api'

const actions = {
  async loadVerificationToken ({ commit },vc) {
    try {
      commit(types.USER_EMAILVERIFICATION_BEGIN);
      const { data } = await api.user.emailVerification(vc);
      commit(types.USER_EMAILVERIFICATION_SUCCESS, data);
    } catch (e) {
      commit(types.USER_EMAILVERIFICATION_ERROR, e);
    }
  },

  async onBoardingSignup ({ commit },formData) {
    try {
      commit(types.ONBOARDING_SIGNUP_BEGIN);
      const { data } = await api.user.onboardingSignup(formData);
      commit(types.ONBOARDING_SIGNUP_SUCCESS, data);
    } catch (e) {
      commit(types.ONBOARDING_SIGNUP_ERROR, e);
    }
  },

  async userSignup ({ commit },formData) {
    try {
      commit(types.USER_SIGNUP_BEGIN);
      const { data } = await api.user.register(formData);
      commit(types.USER_SIGNUP_SUCCESS, data);
    } catch (e) {
      commit(types.USER_SIGNUP_ERROR, e);
    }
  },

  async verifyEmail ({ commit },vc) {
    try {
      commit(types.VERIFY_EMAIL_BEGIN);
      const { data } = await api.user.verifyEmail(vc);
      commit(types.VERIFY_EMAIL_SUCCESS, data);
    } catch (e) {
      commit(types.VERIFY_EMAIL_ERROR, e);
    }
  },

  async importUsers ({ commit },file) {
    try {
      commit(types.IMPORT_USERS_BEGIN);
      const { data } = await api.user.importUsers(file);
      commit(types.IMPORT_USERS_SUCCESS, data);
    } catch (e) {
      commit(types.IMPORT_USERS_ERROR, e.response ? e.response.data : e);
    }
  },

  async resendVerification ({ commit },id) {
    try {
      commit(types.RESEND_EMAILVERIFICATION_BEGIN);
      const { data } = await api.user.resendemailverification(id);
      commit(types.RESEND_EMAILVERIFICATION_SUCCESS,data);
    } catch (e) {
      commit(types.RESEND_EMAILVERIFICATION_ERROR,e);
    }
  }
}

export default actions
